module.exports = function (data) {
    return {
        event: 'BWScrossSellProductView',
        eventContext: {
            area: 'product page',
            product: {
                price: data.Price,
                productInfo: {
                    productName: data.ProductData.name,
                    brandName: data.ProductData.brandName,
                    productTitle: data.ProductData.title,
                    wasUnitPrice: data.WasPrice,
                    currentUnitPrice: data.Price,
                    isSpecial: data.IsOnSpecial,
                    webPackType: data.ProductData.webpacktype,
                    productUnitQuantity: data.ProductData.productunitquantity,
                    productSKU: data.Stockcode,
                    parentstockcode: data.ProductData.parentstockcode,
                    liquorSize: data.ProductData.liquorsize,
                    liquorStyle: data.ProductData.liquorstyle,
                    vintage: data.ProductData.vintage,
                    varietal: data.ProductData.varietal,
                    countryOfOrigin: data.ProductData.countryoforigin,
                    regionOfOrigin: data.ProductData.regionoforigin,
                    stateOfOrigion: data.ProductData.stateoforigin,
                    boAvailability: data.BackorderStockOnHand > 0,
                    foAvailability: data.StockOnHand > 0
                }
            },
            typeOfCrossSell: 'google shop'
        }
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/cards/detail/product/atm-mapper-product-view-cross-sell.js
 **/